module.exports = __webpack_public_path__ + "static/media/switch-on.36f374fd.svg";